import React from 'react';

import RescheduleClassesViewStageRow from '../RescheduleClassesViewStageRow';
import styles from './RescheduleClassesViewStageTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

export default function RescheduleClassesViewStageTable({
  sbatGroups,
  ...rescheduleRowProps
}) {
  return (
    <Table className={styles.table}>
      <TableHead className={styles.header}>
        <TableRow>
          <TableCell className={styles.dateTime}>Date & Time</TableCell>
          <TableCell className={styles.topic}>Topic</TableCell>
          <TableCell className={styles.batch}>Batch/es</TableCell>
          <TableCell className={styles.module}>Module Name</TableCell>
          <TableCell className={styles.instructor}>
            Primary, Secondary Instructor
          </TableCell>
          <TableCell className={styles.schedule}>Shift Lectures</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sbatGroups.map((sbatGroup) => (
          <RescheduleClassesViewStageRow
            sbatGroup={sbatGroup}
            key={sbatGroup.id}
            {...rescheduleRowProps}
          />
        ))}
      </TableBody>
    </Table>
  );
}
